import script from "./RecommendInstallation.vue?vue&type=script&setup=true&lang=js"
export * from "./RecommendInstallation.vue?vue&type=script&setup=true&lang=js"

import "./RecommendInstallation.vue?vue&type=style&index=0&id=487f4670&scoped=true&lang=css"
import "./RecommendInstallation.vue?vue&type=style&index=1&id=487f4670&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-487f4670"]])

export default __exports__